import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudNetwork = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'network/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllNetwork = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_network_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudNetwork = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'network/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudNetwork = (data, id) => {
  let url = privateCloudBaseUrl + 'network/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudNetwork = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'network/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
